import { Box, Divider, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import classnames from 'classnames';
import React, { FC, useMemo } from 'react';

import { TLocalesKeys } from '../../../../types';
import { useIsAiChatbot } from '../../../common/hooks/useIsAiChatbot';
import { renderModel } from '../../../util/renderModel';
import { useIsSmallScreen } from '../../hooks';
import s from './styles.scss';

const isStudioEditor = renderModel.isStudioEditor();

export const LegalDisclaimer: FC = () => {
  const { t } = useTranslation();
  const isAiChatbot = useIsAiChatbot();

  const isSmallScreen = useIsSmallScreen();

  const classNames = useMemo(() => classnames({ [s.fullPage]: !isSmallScreen }), [isSmallScreen]);

  if (!isAiChatbot) {
    return null;
  }

  return (
    <Box direction="vertical" gap="SP3" color="D10" align="center" textAlign="center">
      <Text size="tiny" weight="thin" secondary className={classNames}>
        {t<TLocalesKeys>('chatbot_legal_disclaimer')}
      </Text>
      <Box className={classnames(s.divider, { [s.studioEditor]: isStudioEditor })}>
        <Divider />
      </Box>
    </Box>
  );
};
